import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
  signal,
} from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { QarepaBaseSubsDirective } from '@qarepa/common';
import { CompanyService } from '@qaroni-app/company/services/company.service';
import { Company } from '@qaroni-app/company/types/company';
import { qaroniAnimations } from '@qaroni-shared/animations/qaroni-animations';
import { shareReplay } from 'rxjs/operators';

@Component({
  selector: 'qaroni-company-widget',
  templateUrl: './company-widget.component.html',
  styleUrls: ['./company-widget.component.scss'],
  animations: [qaroniAnimations.enterFadeIn()],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CompanyWidgetComponent
  extends QarepaBaseSubsDirective
  implements OnInit
{
  private route = inject(ActivatedRoute);
  private companyService = inject(CompanyService);

  public $company = signal<Company | null>(null);

  private company$ = this.companyService.getCompany$().pipe(shareReplay(1));
  private paramMap$ = this.route.paramMap;

  ngOnInit(): void {
    this.subs.add(this.company$.subscribe(this.getCompany));
    this.subs.add(this.paramMap$.subscribe(this.getParamMap));
  }

  get goToUpdateCompany(): string[] {
    return [`/companies/${this.$company().companyId}/update`];
  }

  get company() {
    return this.$company();
  }

  public getPhoneLink(phone: string | null | undefined): string {
    return phone ? `tel:${phone}` : '';
  }

  public getMailLink(email: string | null | undefined): string {
    return email ? `mailto:${email}` : '';
  }

  private getCompany = (company: Company) => {
    if (company?.companyId) {
      this.$company.set(company);
    }
  };

  private getParamMap = (paramMap: ParamMap): void => {
    if (paramMap.has('companyID')) {
      const companyID = parseInt(paramMap.get('companyID'));
      this.companyService.getCompany(companyID);
    }
  };
}
